$(document).ready(function(){
  //subscriptionpopup
  $(".subscription-popup").on("click", function(e) {
    e.preventDefault();
    if ($(".btn").hasClass("active")) {
      $("body").removeClass("subscription-open");
      $(".subscription-popup-wrapper").removeClass("popup-open");
    }
    else {
      $("body").addClass("subscription-open");
      $(".subscription-popup-wrapper").addClass("popup-open");
    }
  });
  $(".close-subscription").on("click", function(e){
    $("body").removeClass("subscription-open");
    $(".subscription-popup-wrapper").removeClass("popup-open");
  });
  //marque
  $(function() {
      $('.js-conveyor').jConveyorTicker();
  });

  $('.quotes-slide').slick({
    dots: false,
    infinite: true,
    speed: 800,
    autoplay: true,
    slidesToShow: 7,
    slidesToScroll: 1,    
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }     
    ]
  });
  //center
  $('.reviews-slide').slick({
    centerMode: true,
    centerPadding: '30px',
    dots: true,
    slidesToShow: 4,
    autoplay: true,
    autoplaySpeed: 500,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '30px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '15px',
          slidesToShow: 1
        }
      }
    ]
  });
  // Trigger the slide-in effect on scroll
  $(window).scroll(function () {    
    $(".animation").each(function (i) {
      var bottomWindow = $(window).scrollTop() + $(window).height();
      var Objecttop = $(this).offset().top
      var bottomObject = $(this).offset().top + $(this).outerHeight() / 2;
      var test =  bottomWindow - Objecttop

      if (bottomWindow > bottomObject) {
        $(this).addClass("animation-visible");

      } else {
       // $(this).removeClass("animation-visible");
      // number--;
      }
    });
  });
  //accordion
  $(".faq-content-block > a").on("click", function(e) {
    e.preventDefault();
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".content").slideUp(200);        
    } else {        
      $(".faq-content-block > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this).siblings(".content").slideDown(200);
    }
  });    
  $(".close-bar").click(function(){
    $(".overlay-popup-custom").addClass("remove");
  }); 
});  


//timeclock
$(function () {
  $('#clock').showTimer({returnType: "box", wrapper_id: "timewrapper"});
});
